import React from "react";
import FeedList from "../../../userfeeds/userfeed_list"

const RecruitmentTab = ({ data }) => {
  const { circleId, currentUser, companyId, hashedCompanyId } = data;

  return (
    <div className="profile-details">
      <div className="recruitment-list text-center mt-4 mb-1">
        <FeedList
          currentUser={currentUser || {}}
          companyId={companyId || null}
          hashedCompanyId={hashedCompanyId || null}
          circleId={circleId || null}
        />
        {!companyId && (
          <div 
            className="mx-auto mt-0 mb-4 p-3"
            style={{
              maxWidth: '722px',
              background: '#f8f8f8',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              fontSize: '14px',
              lineHeight: '1.6',
              color: '#333'
            }}
          >
            トークルームの投稿はアプリのみ可能です。
          </div>
        )}
        {companyId && (
          <div 
            className="container col-lg-8 a-button a-button__top a-button--orange mx-auto mb-1 text-fw-bold" 
            style={{
              position: 'sticky',
              maxWidth: '200px',
              bottom: '3%', 
              borderRadius: '20px'
            }}
          >
            <a href={`/community/${hashedCompanyId}/userfeeds/new?circle_id=${circleId} `}>
              <p 
                className="mb-0 mt-1" 
                style={{
                  color: '#fff',
                  marginLeft: '8px',
                  marginRight: '8px',
                  fontSize: '13px'
                }}
              >
                <img 
                  className="mb-1" 
                  src={`/assets2019/add_circle_icon_ver_white.svg`} width="24" 
                  alt=""
                />
                お題を投稿する
              </p>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecruitmentTab;
